// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  isMockEnabled: true,
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  firebase: {
    apiKey: 'AIzaSyBh35yeTmKwVpKOvpOcwsHjmft3W6GTlF4',
    authDomain: 'majdi-test-8e820.firebaseapp.com',
    databaseURL: 'https://majdi-aa1c1-default-rtdb.firebaseio.com/',
    projectId: 'majdi-test-8e820',
    storageBucket: 'majdi-test-8e820.firebasestorage.app',
    messagingSenderId: '1097620992758',
    appId: '1:1097620992758:web:89d4c562947129f5a432d7',
    measurementId: 'G-BGLMM8KWB1',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
